<template>
    <a-table :columns="columns" :dataSource="data" :pagination="false">
        <a-popover slot="truck" slot-scope="truckObj" placement="right" >
            <template slot="title">
                <i class="fa fa-truck" aria-hidden="true"></i>
                <span>Details</span>
            </template>
            <template slot="content">
                <div>
                    <span>Model: {{truckObj.model}}</span>
                </div>
                <div>
                    <span>GVM: {{truckObj.gvm / 1000}} tonnes</span>
                </div>
            </template>
            {{truckObj.plate}}
        </a-popover>
        <div slot="revenue" slot-scope="revenue">
            ${{revenue}}
        </div>
        <div slot="costs" slot-scope="costs">
            ${{costs}}
        </div>
        <div slot="profit" slot-scope="profit">
            ${{profit}}
        </div>
        <div slot="utilisation" slot-scope="utilisation">
            {{utilisation}}%
        </div>
        <a-table
                slot="expandedRowRender"
                :columns="innerColumns"
                :dataSource="innerData"
                :pagination="false"
        >
            <div slot="payload" slot-scope="payload">
                {{payload}} tonnes
            </div>
            <div slot="utilisation" slot-scope="utilisation">
                {{utilisation}}%
            </div>
        </a-table>
    </a-table>
</template>
<script>
    const columns = [
        { title: 'Truck', dataIndex: 'truck', key: 'truck.id', scopedSlots: { customRender: 'truck' }, align: 'center' },
        { title: 'Revenue', dataIndex: 'revenue', key: 'revenue', scopedSlots: { customRender: 'revenue' }, align: 'center' },
        { title: 'Costs', dataIndex: 'costs', key: 'costs', scopedSlots: { customRender: 'costs' }, align: 'center' },
        { title: 'Profit', dataIndex: 'profit', key: 'profit', scopedSlots: { customRender: 'profit' }, align: 'center' },
        { title: 'Operating hours', dataIndex: 'hours', key: 'hours', align: 'center' },
        { title: 'Capacity utilisation', dataIndex: 'utilisation', key: 'utilisation', scopedSlots: { customRender: 'utilisation' }, align: 'center' },
    ];

    const data = [
        {
            key: 1,
            truck: {
                plate: 'KZF321',
                model: 'Volvo FH16',
                gvm: 32000,
            },
            revenue: 500,
            costs: 480,
            profit: 20,
            hours: 8.5,
            utilisation: 70,
        },
        {
            key: 2,
            truck: {
                plate: 'KZF421',
                model: 'Volvo FH14',
                gvm: 28000,
            },
            revenue: 480,
            costs: 580,
            profit: -100,
            hours: 6.5,
            utilisation: 90,
        },
        {
            key: 3,
            truck: {
                plate: 'KZF521',
                model: 'Volvo FH12',
                gvm: 24000,
            },
            revenue: 600,
            costs: 1080,
            profit: -400,
            hours: 8.0,
            utilisation: 50,
        },
        {
            key: 4,
            truck: {
                plate: 'KZF621',
                model: 'Volvo FH12',
                gvm: 24000,
            },
            revenue: 1480,
            costs: 1280,
            profit: 200,
            hours: 7.5,
            utilisation: 70,
        },
        {
            key: 5,
            truck: {
                plate: 'KZF721',
                model: 'Volvo FH12',
                gvm: 24000,
            },
            revenue: 1280,
            costs: 1080,
            profit: 200,
            hours: 8.5,
            utilisation: 50,
        },
    ];

    const innerColumns = [
        { title: 'Point', dataIndex: 'point', key: 'point' },
        { title: 'Location', dataIndex: 'location', key: 'location' },
        { title: 'Time leaving', dataIndex: 'time', key: 'time' },
        { title: 'Stop duration', dataIndex: 'duration', key: 'duration' },
        { title: 'Predicted payload', dataIndex: 'payload', key: 'payload', scopedSlots: { customRender: 'payload' } },
        { title: 'Capacity utilisation', dataIndex: 'utilisation', key: 'utilisation', scopedSlots: { customRender: 'utilisation' } },
    ];

    const innerData = [
        {
            point: 'Start point',
            location: 'Depot',
            time: '9.15 am',
            duration: '10 hours',
            payload: 5,
            utilisation: 50,
        },
        {
            point: 'Stop 1',
            location: 'Customer 1',
            time: '9.45 am',
            duration: '5 minutes',
            payload: 10,
            utilisation: 100,
        },
        {
            point: 'Stop 2',
            location: 'Customer 2',
            time: '10.30 am',
            duration: '10 minutes',
            payload: 7,
            utilisation: 70,
        },
        {
            point: 'End point',
            location: 'Depot',
            time: '12.30 pm',
            duration: '30 minutes',
            payload: 0,
            utilisation: 0,
        },
    ];

    export default {
        data() {
            return {
                data,
                columns,
                innerColumns,
                innerData,
            }
        }
    }
</script>